import { render, staticRenderFns } from "./component-bed1ea29.vue?vue&type=template&id=0b205a26&scoped=true&"
import script from "./component-bed1ea29.vue?vue&type=script&lang=js&"
export * from "./component-bed1ea29.vue?vue&type=script&lang=js&"
import style0 from "./component-bed1ea29.vue?vue&type=style&index=0&id=0b205a26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b205a26",
  null
  
)

export default component.exports